import { AppConstants } from '../model/app-constants.model';

export const appConstants: AppConstants = {
    pendingKanbanItemsAge: 30,
    kanbanPriorityItemAge: 15,
    dateInputMask: [/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.', /[1-2]/, /\d/, /\d/, /\d/],
    customersPageSize: 20,
    passwordRegex: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_?-])(?=.{8,})'),
};
